import React from 'react';
import { connect } from 'dva';
import { Layout, Form, Input, Table, Button, Modal } from 'antd';
import debounce from 'lodash/debounce';
import AppIcon from '@/components/app-icon';
import InfoBar from '@/components/info-bar';
import SidePanel from '@/components/side-panel';
import BlacklistDetails from './blacklist-details';

const columns = [
  {
    title: 'Domain',
    dataIndex: 'domain',
    key: 'domain',
  },
  {
    title: 'Admin User',
    dataIndex: 'adminUser',
    key: 'adminUser',
  },
  {
    title: 'Created At',
    dataIndex: 'createdAt',
    key: 'createdAt',
  },
  {
    title: 'Updated At',
    dataIndex: 'updatedAt',
    key: 'updatedAt',
  },
];

export const ROW_KEY = '_id';

class AdminBlacklist extends React.Component {
  state = {
    showModal: false,
  };

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch({ type: 'blacklistModel/getDomainBlacklist' });
  }

  showBlacklistDetails = () => {
    this.setState({ showModal: true });
  };

  hideBlacklistDetails = () => {
    this.setState({ showModal: false });
  };

  renderSider = () => {
    const {
      blacklistModel: { refineParams },
    } = this.props;

    return (
      <SidePanel type="filter">
        <Form
          layout="vertical"
          initialValues={refineParams}
          onValuesChange={debounce((_, values) => {
            this.props.dispatch({
              type: 'blacklistModel/getDomainBlacklist',
              payload: values,
            });
            this.props.dispatch({
              type: 'blacklistModel/setState',
              payload: {
                refineParams: values,
              },
            });
          }, 500)}
        >
          <Form.Item
            label="Domain"
            name="domain"
          >
            <Input />
          </Form.Item>
        </Form>
      </SidePanel>
    );
  };

  renderTableFooter = () => {
    const {
      blacklistModel: { currentBlacklist },
    } = this.props;

    return currentBlacklist[ROW_KEY] ? (
      <div className="table-footer">
        <div>1 selected</div>
        <div>
          <Button
            type="text"
            onClick={() => {
              Modal.confirm({
                title: 'Warning',
                content: 'This will remove the selected item.',
                cancelButtonProps: { type: 'text' },
                onOk: () => {
                  this.props.dispatch({
                    type: 'blacklistModel/deleteDomainBlacklist',
                  });
                },
              });
            }}
          >
            Delete
          </Button>
        </div>
      </div>
    ) : null;
  };

  onCurrentBlacklistChange = (record = {}) => {
    const {
      blacklistModel: { currentBlacklist },
      dispatch,
    } = this.props;

    const payload = record[ROW_KEY] === currentBlacklist[ROW_KEY] ? {} : record;
    dispatch({ type: 'blacklistModel/onCurrentBlacklistChange', payload });
  };

  render() {
    const {
      blacklistModel: { loading, blacklists, currentBlacklist },
      dispatch,
    } = this.props;
    const { showModal } = this.state;

    return (
      <div>
        <InfoBar
          icon="MCP_app_menu_Roles"
          color="#359e35"
          title="Blacklist"
          subtitle="Manage blacklist in the CEC"
          actions={[
            {
              label: 'New',
              icon: <AppIcon name="add" />,
              onClick: () => {
                this.onCurrentBlacklistChange();
                this.showBlacklistDetails();
              },
            },
          ]}
        />
        <Layout>
          {this.renderSider()}
          <Layout.Content className="page">
            <div className="table-container">
              <Table
                bordered
                size="small"
                rowKey={ROW_KEY}
                loading={loading}
                dataSource={blacklists}
                columns={columns}
                rowSelection={{
                  hideSelectAll: true,
                  selectedRowKeys: [currentBlacklist[ROW_KEY]],
                  onChange: (_, selectedRows) => this.onCurrentBlacklistChange(selectedRows[0]),
                }}
                onRow={(record) => ({
                  onClick: () => this.onCurrentBlacklistChange(record),
                })}
                pagination={false}
              />
              {this.renderTableFooter()}
            </div>
          </Layout.Content>
        </Layout>
        {showModal && (
          <BlacklistDetails
            onCancel={this.hideBlacklistDetails}
            dispatch={dispatch}
            blacklist={currentBlacklist}
          />
        )}
      </div>
    );
  }
}

export default connect(({ blacklistModel }) => ({
  blacklistModel,
}))(AdminBlacklist);
